/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EntitiesBrandListResponse,
  EntitiesBrandMain,
  ListBrandsParams
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Show brand
 */
export const showBrand = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesBrandMain>(
      {url: `/api/v3/brands/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowBrandInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/brands/${id}`
    ] as const;
    }

export const getShowBrandQueryKey = (id: number,) => {
    return [
    `/api/v3/brands/${id}`
    ] as const;
    }


export const useShowBrandInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowBrandInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showBrand>>> = ({ signal }) => showBrand(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowBrandInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showBrand>>>
export type ShowBrandInfiniteQueryError = ErrorType<unknown>


export function useShowBrandInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showBrand>>,
          TError,
          Awaited<ReturnType<typeof showBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showBrand>>,
          TError,
          Awaited<ReturnType<typeof showBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show brand
 */

export function useShowBrandInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowBrandInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show brand
 */
export const prefetchShowBrandInfiniteQuery = async <TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowBrandInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowBrandInfinite} query
 */
export const invalidateShowBrandInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowBrandInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowBrandQueryOptions = <TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowBrandQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showBrand>>> = ({ signal }) => showBrand(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowBrandQueryResult = NonNullable<Awaited<ReturnType<typeof showBrand>>>
export type ShowBrandQueryError = ErrorType<unknown>


export function useShowBrand<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showBrand>>,
          TError,
          Awaited<ReturnType<typeof showBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrand<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showBrand>>,
          TError,
          Awaited<ReturnType<typeof showBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrand<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show brand
 */

export function useShowBrand<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowBrandQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show brand
 */
export const prefetchShowBrandQuery = async <TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowBrandQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowBrand} query
 */
export const invalidateShowBrand = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowBrandQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowBrandSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowBrandQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showBrand>>> = ({ signal }) => showBrand(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowBrandSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showBrand>>>
export type ShowBrandSuspenseQueryError = ErrorType<unknown>


export function useShowBrandSuspense<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandSuspense<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandSuspense<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show brand
 */

export function useShowBrandSuspense<TData = Awaited<ReturnType<typeof showBrand>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowBrandSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowBrandSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowBrandInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showBrand>>> = ({ signal }) => showBrand(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowBrandSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showBrand>>>
export type ShowBrandSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowBrandSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowBrandSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show brand
 */

export function useShowBrandSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showBrand>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showBrand>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowBrandSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List brands
 */
export const listBrands = (
    params?: ListBrandsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesBrandListResponse>(
      {url: `/api/v3/brands`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListBrandsInfiniteQueryKey = (params?: ListBrandsParams,) => {
    return [
    'infinite', `/api/v3/brands`, ...(params ? [params] : [])
    ] as const;
    }

export const getListBrandsQueryKey = (params?: ListBrandsParams,) => {
    return [
    `/api/v3/brands`, ...(params ? [params] : [])
    ] as const;
    }


export const useListBrandsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(params?: ListBrandsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrands>>> = ({ signal }) => listBrands(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>
export type ListBrandsInfiniteQueryError = ErrorType<void>


export function useListBrandsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params: undefined |  ListBrandsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List brands
 */

export function useListBrandsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListBrandsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List brands
 */
export const prefetchListBrandsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 queryClient: QueryClient, params?: ListBrandsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListBrandsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListBrandsInfinite} query
 */
export const invalidateListBrandsInfinite = async (
 queryClient: QueryClient, params?: ListBrandsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListBrandsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListBrandsQueryOptions = <TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(params?: ListBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrands>>> = ({ signal }) => listBrands(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>
export type ListBrandsQueryError = ErrorType<void>


export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params: undefined |  ListBrandsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List brands
 */

export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListBrandsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List brands
 */
export const prefetchListBrandsQuery = async <TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 queryClient: QueryClient, params?: ListBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListBrandsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListBrands} query
 */
export const invalidateListBrands = async (
 queryClient: QueryClient, params?: ListBrandsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListBrandsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListBrandsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrands>>> = ({ signal }) => listBrands(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>
export type ListBrandsSuspenseQueryError = ErrorType<void>


export function useListBrandsSuspense<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params: undefined |  ListBrandsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsSuspense<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsSuspense<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List brands
 */

export function useListBrandsSuspense<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListBrandsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListBrandsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrands>>> = ({ signal }) => listBrands(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>
export type ListBrandsSuspenseInfiniteQueryError = ErrorType<void>


export function useListBrandsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params: undefined |  ListBrandsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List brands
 */

export function useListBrandsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listBrands>>>, TError = ErrorType<void>>(
 params?: ListBrandsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListBrandsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






